/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { Pong } from '../../models/pong';

export interface Ping$Params {
  query: string;
}

export function ping(http: HttpClient, rootUrl: string, params: Ping$Params, context?: HttpContext): Observable<DapiHttpResponse<Pong>> {
  const rb = new DapiRequestBuilder(rootUrl, ping.PATH, 'get');

  if (params) {
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<Pong>;
    }),
    catchErrorAsJson()
  );
}

ping.PATH = '/api/instantsearch/ping';
